export const LOGOUT = "LOGOUT";
export const SET_TOKEN = "SET_TOKEN";
